import {BaseService} from './Core/BaseService';

class SurveySubmissionService extends BaseService {
    get Url() { return super.Url + "/surveySubmissions"; }
    get ModelName() { return "Survey Submission"; }
    get PrimaryKeyProperty() { return "surveySubmissionId"; }

    /**
     * Returns the current active submissions for a CA, optionally filtered by survey type.
     * Result is an array of SurveySubmission objects.
     */
    GetAll(conservationActionId, surveyTypeId = null) {
        return this.SendRequest(BaseService.GET, { conservationActionId, ...(surveyTypeId ? { surveyTypeId } : {}) });
    }

    /**
     * Returns the single current active submission for a CA + survey type, or null.
     * Convenience wrapper around GetAll for callers that expect exactly one result.
     */
    GetCurrent(conservationActionId, surveyTypeId) {
        return this.GetAll(conservationActionId, surveyTypeId)
            .then(r => ({ ...r, result: r?.result?.[0] ?? null }));
    }

    /**
     * Returns the computed project-list survey status for a program/sub-program:
     * { tagsByContextNodeId, rollupCountsBySubProgramContextNodeId }. Tag selection
     * and the actionable rollup are computed server-side for the caller's role;
     * the program view renders the result as-is.
     */
    GetForParent(programId) {
        return this.SendRequest(BaseService.GET, { programId });
    }

    /**
     * Supplier submits the survey for review.
     * Body: { conservationActionId, surveyTypeId }
     */
    Submit(body) {
        return this.SendRequest(BaseService.POST, body, null, '/submit');
    }

    /**
     * Returns the survey to an editable state.
     * Body: { conservationActionId, surveyTypeId, notes }
     * Notes are required on every unsubmit path (400 if empty). Reopening a
     * review-complete survey additionally requires review_survey_submissions.
     */
    Unsubmit(body) {
        return this.SendRequest(BaseService.POST, body, null, '/unsubmit');
    }

    /**
     * TFT accepts the survey and auto-advances the project phase.
     * Body: { conservationActionId, surveyTypeId }
     */
    Accept(body) {
        return this.SendRequest(BaseService.POST, body, null, '/accept');
    }
}

export const service = new SurveySubmissionService();
